<div *ngIf="component | gcGetComponentApplicableForPDF">
  <ng-container *ngIf="component.type !== 'content'">
    <ng-container *ngIf="component.isLayoutComponent; else nonLayout">
      <div class="layout-component-wrapper" 
        [ngClass]="'component-' + component.type"
        [ngSwitch]="component.type">
        <!-- Fieldset -->
        <ng-container *ngSwitchCase="'fieldset'">
          <legend>
            {{ component.legend }}
          </legend>
          <div class="ps-3">
            <gc-application-pdf-component *ngFor="let component of component.components"
              [component]="component | gcMapComponentForPDF: form.referenceFields"
              [form]="form"
              [getFormAnswerMap]="getFormAnswerMap">
            </gc-application-pdf-component>
          </div>
        </ng-container>

        <!-- Panel -->
        <ng-container *ngSwitchCase="'panel'">
          <legend>
            {{ component.title }}
          </legend>
          <div class="p-3">
            <gc-application-pdf-component *ngFor="let component of component.components"
              [component]="component | gcMapComponentForPDF: form.referenceFields"
              [form]="form"
              [getFormAnswerMap]="getFormAnswerMap">
            </gc-application-pdf-component>
          </div>
        </ng-container>

        <!-- Well -->
        <ng-container *ngSwitchCase="'well'">
          <div class="p-3">
            <gc-application-pdf-component *ngFor="let component of component.components"
              [component]="component | gcMapComponentForPDF: form.referenceFields"
              [form]="form"
              [getFormAnswerMap]="getFormAnswerMap">
            </gc-application-pdf-component>
          </div>
        </ng-container>

        <!-- Columns -->
        <div *ngSwitchCase="'columns'"
          class="d-flex">
          <div *ngFor="let column of component.columns; let last = last;"
            [class.pe-3]="!last"
            class="ps-0"
            [ngClass]="column | gcGetColumnClass">
            <gc-application-pdf-component *ngFor="let component of column.components"
              [component]="component | gcMapComponentForPDF: form.referenceFields"
              [form]="form"
              [getFormAnswerMap]="getFormAnswerMap">
            </gc-application-pdf-component>
          </div>
        </div>

        <!-- Table -->
        <table *ngSwitchCase="'table'">
          <tr *ngFor="let row of component.rows">
            <td *ngFor="let cell of row">
              <gc-application-pdf-component
                *ngFor="let cellComponent of cell.components"
                [component]="cellComponent | gcMapComponentForPDF: form.referenceFields"
                [form]="form"
                [getFormAnswerMap]="getFormAnswerMap">
              </gc-application-pdf-component>
            </td>
          </tr>
        </table>
      </div>
    </ng-container>

    <ng-template #nonLayout>
      <div class="comp-wrapper">
        <div class="component-label-wrapper">
          <div class="component-label"
            [innerHtml]="component.label | escapeHtml">
          </div>
          <div *ngIf="component.validate?.required"
            class="required-label">
            *
          </div>
        </div>
        <small class="d-block"
          [innerHtml]="component.description | escapeHtml">
        </small>

        <!-- Answers for Standard -->
        <div *ngIf="(
          component.referenceField?.type !== RefTypes.Table &&
          component.referenceField?.type !== RefTypes.Subset &&
          !(
            component.referenceField?.type === RefTypes.TextArea &&
            component.referenceField?.isRichText
          )
        )"
          class="component-response"
          [innerHTML]="getFormAnswerMap[form.applicationFormId] | fireFunction: component">
        </div>

        <!-- Rich Text -->
        <div *ngIf="component.referenceField?.type === RefTypes.TextArea &&
          component.referenceField?.isRichText">
          <yc-rich-text-display
            [html]="getFormAnswerMap[form.applicationFormId] | fireFunction: component">
          </yc-rich-text-display>
        </div>

        <!-- Data sets -->
        <div *ngIf="component.referenceField?.type === RefTypes.Subset">
          <ng-template *ngTemplateOutlet="tableRecordCount; context: {
            total: component.totalTableRows
          }">
          </ng-template>
          <table class="table yc-table">
            <thead>
              <th>
                {{ component.referenceField.name }}
              </th>
              <th>
                {{ component.referenceField.subsetCollectionType | gcDataSetCollectionLabel }}
              </th>
            </thead>
            <tbody>
              <tr *ngFor="let column of component.visibleColumns">
                <td>
                  {{ column.label }}
                </td>
                <td *ngFor="let row of (getFormAnswerMap[form.applicationFormId] |
                  fireFunction: component)">
                  {{ row.responses[column.referenceField.key] | gcDataSetCollectionData :
                  component.referenceField.subsetCollectionType }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Tables -->
        <div *ngIf="component.referenceField?.type === RefTypes.Table">
          <ng-template *ngTemplateOutlet="tableRecordCount; context: {
            total: component.totalTableRows
          }">
          </ng-template>
          <div class="d-flex flex-wrap">
            <div *ngFor="let row of (getFormAnswerMap[form.applicationFormId] |
              fireFunction: component); let last = last;"
              class="table-cell"
              [class.table-cell-not-last]="!last">
              <div *ngFor="let column of component.visibleColumns"
                class="d-flex mb-3">
                <div class="table-row-label">
                  {{ column.label }}: 
                </div>
                <div *ngIf="column.referenceField.type !== RefTypes.Currency"
                  class="table-row-answer">
                  <ng-container *ngIf="column.referenceField.supportsMultiple">
                    {{ row.responses[column.referenceField.key] | ycJoinArray }}
                  </ng-container>
                  <ng-container *ngIf="!column.referenceField.supportsMultiple">
                    {{ row.responses[column.referenceField.key] }}
                  </ng-container>
                </div>
                <div *ngIf="column.referenceField.type === RefTypes.Currency"
                  class="table-row-answer">
                  {{ row.responses[column.referenceField.key] | gcMoney }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

  </ng-container>

  <ng-container *ngIf="component.type === 'content' && component.html">
    <yc-rich-text-display 
      [html]="component.html">
    </yc-rich-text-display>
  </ng-container>


  <!-- Record Count -->
  <ng-template #tableRecordCount
    let-total="total">
    <yc-i18n key="common:textRecords"
      defaultValue="Records">
    </yc-i18n>:
    {{ total }}
  </ng-template>
</div>
